import React, {useEffect, useState} from 'react'
import {connect} from "react-redux";
import {adminHttp} from "~/Admin/services/http";
import deleteIcon from "~/assets/icons/delete.png";
import ConfirmedLink from "~/Components/ConfirmedButton/ConfirmedLink";
import {EditIcon} from "~/Components/Icons/Icons";
import Pagination from "react-js-pagination";
import AdminAddDietary from "./AdminAddDietary";
import AdminEditDietary from "./AdminEditDietary";

const AdminDietaries = ({match, event, user, ...props}) => {

    const [response, setResponse] = useState({});

    const loadData = (page = 1) => {
        adminHttp
            .get('/dietaries?page=' + page)
            .then(res => setResponse(res.data));
    };

    const handleDelete = (id) => {
        adminHttp
            .delete('/dietaries/' + id)
            .then(res => {
                loadData()
            });
    }

    useEffect(loadData, [event]);

    if (!Object.keys(response).length) {
        return <></>;
    }

    return (
        <div className="admin-inventory">
            <div className="row">
                <div className="col-8">
                    <h1>Dietaries Management</h1>
                </div>
                <div className="col-4 text-right">
                    <AdminAddDietary onChange={loadData} className="btn btn-primary btn-sm">+ Add New</AdminAddDietary>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <div className="card shadow-sm bg-white mt-3">
                        <div className="card-body">
                            <table className="table">

                                <thead>
                                <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">Name</th>
                                    <th scope="col">Display Order</th>
                                    <th scope="col"></th>
                                </tr>
                                </thead>

                                <tbody>
                                {response.data.map(u => (
                                    <tr key={u.id}>
                                        <th scope="col">{u.id}</th>
                                        <td scope="col">{u.name}</td>
                                        <td scope="col">{u.display_order}</td>
                                        <td scope="col">

                                            <AdminEditDietary key={u.updated_at} id={u.id} onChange={loadData}
                                                              className="cursor-pointer d-inline">
                                                <EditIcon classes="d-inline mr-2"/>
                                            </AdminEditDietary>

                                            {!u.other && (
                                                <ConfirmedLink className="cursor-pointer d-inline"
                                                               onClick={() => handleDelete(u.id)}>
                                                    <img src={deleteIcon}/>
                                                </ConfirmedLink>
                                            )}

                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                            {response.per_page < response.total && (
                                <Pagination
                                    activePage={response.current_page}
                                    itemsCountPerPage={response.per_page}
                                    totalItemsCount={response.total}
                                    pageRangeDisplayed={5}
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    onChange={loadData}
                                />
                            )}
                        </div>
                    </div>

                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
});

export default connect(mapStateToProps)(AdminDietaries);
